import React, {useLayoutEffect} from "react";

const UseScrollContainerRef = () => {
    const parentRef = React.useRef<HTMLElement | null>(null);
    const [width, setWidth] = React.useState<number>(0);
    const [height, setHeight] = React.useState<number>(0);

    useLayoutEffect(() => {
        if (!parentRef.current) {
            parentRef.current = document.getElementById('home__scrollContainer');
        }

        const handleResize = () => {
            if (parentRef.current) {
                setWidth(parentRef.current.offsetWidth);
                setHeight(parentRef.current.offsetHeight);
            }
        };

        handleResize();

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return {ref: parentRef, width, height};

}

export default UseScrollContainerRef;
